import type {
  TradingPartnerContactEntry as ProtoTradingPartnerContactEntry,
  TradingPartnerListItem as ProtoTradingPartnerListItem,
} from '@ebalance/proto/bffuser/v1/occto_master_model_pb'

import type {
  TradingPartnerContactRow,
  TradingPartnerRow,
} from '~/pages/AdminOcctoMaster/tabs/TradingPartner/models/types'

function convertTradingPartnerContactEntry(
  c: ProtoTradingPartnerContactEntry,
): TradingPartnerContactRow {
  return {
    id: c.id,
    department: c.department,
    name: c.name,
    phone: c.phone,
    email: c.email,
  }
}

/**
 * List*Partners response の 1 item を一覧表示行へ変換する。
 *
 * 発電販売 / 需要調達 / 需要抑制 の 3 タブはいずれも `TradingPartnerListItem` を返すため、
 * 変換ロジックを共通化する (= 旧来は各 hook が同一の convertItem を重複定義していた)。
 * `accounts` は一覧画面の 2 階層展開子行 (spec AC-T09/AC-T10) を描画するために
 * codeName / weekdayContacts / holidayContacts を含めて保持する。
 */
export function convertTradingPartnerListItem(
  item: ProtoTradingPartnerListItem,
): TradingPartnerRow {
  return {
    id: item.id,
    name: item.name,
    shortName: item.shortName,
    accounts: item.accounts.map((a) => ({
      areaCode: a.areaCode,
      code: a.code,
      codeName: a.codeName,
      weekdayContacts: a.weekdayContacts.map(convertTradingPartnerContactEntry),
      holidayContacts: a.holidayContacts.map(convertTradingPartnerContactEntry),
    })),
    updatedAt: item.updatedAt,
    updatedBy: item.updatedBy,
  }
}
